import {useState} from 'react';
import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Multiselect from 'multiselect-react-dropdown';

import { throwToast } from '../../../utils/UIUtils';
import { renderClasses, applySelection, readClasses, getSchema } from '../../../utils/SchemaUtils';
import { renderFillParameters, renderDatasetGroups, getDatasetGroups } from '../../../utils/ParametersUtils';
import { getIndexStructures } from "../../../utils/IndexStructureAPI"

export class IndexModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: this.props.show,
      // selectedIndexStructure: this.props.indexStructure ? this.props.indexStructure : null,
      indexStructures: []
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }


  handleSubmit(event) {
    event.preventDefault();

    if (this.indexStructure.value) {
       var is = this.state.indexStructures.find(el => el.id == this.indexStructure.value)
       if (is.parameters) {
         var bindings = []
         for (var param of is.parameters) {
           bindings.push({"name" : param.name, "value": this[param.name].value})
         }
       }
    }

    if (this.props.index && this.props.index.id) {
      this.props.onUpdate(this.props.index.id,
                          this.name.value,
                          this.indexStructure.value,
                          this.indexEngine.value,
                          getDatasetGroups(this.props.dataset, this),
                          bindings
                        )
    } else {
      this.props.onOK(this.name.value,
                      this.indexStructure.value,
                      this.indexEngine.value,
                      getDatasetGroups(this.props.dataset, this),
                      bindings
                    )
    }
  }

  componentDidMount() {
    if (this.props.project) {
      getIndexStructures(null, this.props.project.id)
        .then(response => {
          this.setState({ indexStructures: response.data })
        })
    } else {
      getIndexStructures(null)
        .then(response => {
          this.setState({ indexStructures: response.data })
        })
    }
  }

  componentDidUpdate() {
    if (this.props.index && this.indexStructure.value == '') {
       this.indexStructure.value = this.props.index.indexStructureId
       // console.log(this.props.index);
       // console.log(this.props.indexEngines);
       this.updateIndexer(this.indexStructure.value);
    }
  }

  updateIndexer(indexer) {
    for (var is of this.state.indexStructures) {
      if (is.id == indexer) {
        this.setState( { validIndexer: is.indexer } )
      }
    }
    // for (var indexer of this.props.indexEngines) {
    //   if (indexer.indexer === this.props.index.elasticConfiguration) {
    // //     console.log(indexer);
    // // //    this.setState( { selectedIndexer: indexer.indexer  })
    // //    break;
    // // }
  }


  findParameterValue(parameter) {
    if (this.props.index && this.props.index.binding) {
      var r = this.props.index.binding.filter(e => e.name === parameter)
      if (r.length > 0) {
        return r[0].value;
      }
    }
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onClose} animation={false} backdrop="static" >
        <Form onSubmit={this.handleSubmit}>
          <Modal.Header>
            <Modal.Title>{this.props.index ? 'Edit' : 'New'} Index</Modal.Title>
          </Modal.Header>
          <Modal.Body>

          <Form.Group>
            <Form.Label className="required">Name</Form.Label>
            <Form.Control ref={node => (this.name = node)}
                 onChange={() => this.setState({ error: false })}
                 pattern="\S.*"
                 defaultValue={this.props.index ? this.props.index.name : ""}
                 required/>
          </Form.Group>

            <Form.Group>
              <Form.Label className="required">Index Definition</Form.Label>
              <Form.Control as="select" ref={node => (this.indexStructure = node)}
                            onChange={() => this.updateIndexer(this.indexStructure.value) }
                            defaultValue=''
                            disabled={this.props.index && this.props.index.createState && this.props.index.createState.state != 'NOT_CREATED'}
                            required>
                <option key={0} value='' disabled>--- Select ---</option>
                {this.state.indexStructures.map((entry, index) =>
                   <option key={index + 1} value={entry.id}>{entry.identifier}</option>)}
              </Form.Control>
            </Form.Group>

            {//this.props.indexEngines.length > 1 &&
              <Form.Group>
              <Form.Label className="required">Index engine</Form.Label>
              <Form.Control as="select" ref={node => (this.indexEngine = node)}
                            defaultValue={this.props.index ? this.props.index.indexEngine : (this.props.indexEngines.length == 1 ? this.props.indexEngines[0] : '')}
                            disabled={this.props.index && this.props.index.createState && this.props.index.createState.state != 'NOT_CREATED'}
                            required>
                <option key={0} value='' disabled>--- Select ---</option>
                {this.props.indexEngines.map((entry, index) => {
                  if (entry.indexer === this.state.validIndexer) {
                    return <option key={index} value={entry.name}>{entry.name}</option>}})}
              </Form.Control>
            </Form.Group>}

            {this.indexStructure && this.indexStructure.value &&
              renderFillParameters(this.state.indexStructures.find(el => el.id == this.indexStructure.value).parameters, this)
            }

            {renderDatasetGroups(this.props.dataset, this.props.index, this)}

          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {this.props.index && this.props.index.id ? 'Update' : 'Create'}
            </Button>
            <Button variant="secondary" onClick={this.props.onClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
  )}
}


export default IndexModal;
